<template>
  <div>
    <article class="program-wrapper">
      <div class="container">
        <p class="title-text">Program Report</p>
        <div class="slide-wrapper">
          <VueSlickCarousel v-bind="settings" v-if="slideList.length > 0">
            <div class="slide" v-for="(item, i) in slideList" :key="i">
              <div class="con">
                <img :src="item.titleImg" alt="img" />
                <p class="text0">{{ item.magazine_name }}</p>
                <p class="text1">{{ item.company }}</p>
                <p class="text1">{{ item.program }}</p>
                <p class="text2">{{ item.summary }}</p>
                <p class="more" @click="showImgView(item)">more</p>
              </div>
            </div>
          </VueSlickCarousel>
        </div>
      </div>
    </article>

    <!-- 이미지 뷰 모달 -->
    <ImageView
      v-if="isimgViewVisible"
      @closeImgView="hideImgView"
      :imgP="imageData.imgP"
      :imgM="imageData.imgM"
    ></ImageView>
  </div>
</template>
<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import ImageView from "@/page/NewGlobal/ImageView.vue";

export default {
  components: { VueSlickCarousel, ImageView },
  data() {
    return {
      settings: {
        dots: true,
        arrows: true,
        infinite: true,
        autoplay: true,
        speed: 1000,
        autoplaySpeed: 9000,
        slidesToShow: 3,
        slidesToScroll: 3,
        cssEase: "linear",
        pauseOnHover: true,
        responsive: [
          {
            breakpoint: 1350,
            settings: {
              arrows: false,
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      },
      slideList: [],
      /* slideList_old: [
        {
          date: "23년 7~8월 호",
          titleImg: require("@/assets/img/newGlobal/main/program/report01.png"),
          title: "C사 Global Language School 과정",
          sub: "현업에 바로 적용할 수 있는 비즈니스 글로벌 능력 향상 과정",
          imgM: "https://kr.object.ncloudstorage.com/newglobal/main/program/program-report_mobile_01.jpg",
          imgP: "https://kr.object.ncloudstorage.com/newglobal/main/program/program-report_pc_01.jpg",
        },
        {
          date: "23년 7~8월 호",
          titleImg: require("@/assets/img/newGlobal/main/program/report02.png"),
          title: "K사 서비스 글로벌 특강",
          sub: "외국인 고객을 응대하는 CS 직원들을 위한 속성 글로벌 특강",
          imgM: "https://kr.object.ncloudstorage.com/newglobal/main/program/program-report_mobile_02.jpg",
          imgP: "https://kr.object.ncloudstorage.com/newglobal/main/program/program-report_pc_02.jpg",
        },
        {
          titleImg: require("@/assets/img/newGlobal/main/program/report03.png"),
          date: "23년 7~8월 호",
          title: "S사 건설부문 Biz-Up Skill 과정",
          sub: "비즈니스 회화부터 시작해 건설 글로벌역량, Biz-Skill까지!",
          imgM: "https://kr.object.ncloudstorage.com/newglobal/main/program/program-report_mobile_03.jpg",
          imgP: "https://kr.object.ncloudstorage.com/newglobal/main/program/program-report_pc_03.jpg",
        },
        {
          titleImg: require("@/assets/img/newGlobal/main/program/report04.png"),
          date: "23년 5~6월 호",
          title: "K사 인재개발원 글로벌 역량 향상과정",
          sub: "세계로 나아가는 글로벌 인재 필수코스",
          imgM: "https://kr.object.ncloudstorage.com/newglobal/main/program/program-report_mobile_04.jpg",
          imgP: "https://kr.object.ncloudstorage.com/newglobal/main/program/program-report_pc_04.jpg",
        },
        {
          titleImg: require("@/assets/img/newGlobal/main/program/report05.png"),
          date: "23년 5~6월 호",
          title: "S사 Global Business English Program",
          sub: "학습자의 비즈스킬 능력 역량강화 프로그램",
          imgM: "https://kr.object.ncloudstorage.com/newglobal/main/program/program-report_mobile_05.jpg",
          imgP: "https://kr.object.ncloudstorage.com/newglobal/main/program/program-report_pc_05.jpg",
        },
        {
          titleImg: require("@/assets/img/newGlobal/main/program/report06.png"),
          date: "23년 5~6월 호",
          title: "S사 셀프 리더십 워크숍",
          sub: "대리-주임 승진자들을 위한 조직 성과 향상을 위한 프로그램",
          imgM: "https://kr.object.ncloudstorage.com/newglobal/main/program/program-report_mobile_06.jpg",
          imgP: "https://kr.object.ncloudstorage.com/newglobal/main/program/program-report_pc_06.jpg",
        },
      ], */

      isimgViewVisible: false,
    };
  },
  mounted() {
    this.getProgram();
  },
  methods: {
    showImgView(item) {
      this.isimgViewVisible = true;
      this.imageData = {
        imgP: item.imgP,
        imgM: item.imgM,
      };
    },

    hideImgView() {
      this.isimgViewVisible = false;
    },

    getProgram() {
      const params = {
        limit: 6,
      };
      axios
      .get("/rest/external/getPrograms", {params: params})
      .then((res) => {
        if (res.data.err == 0) {
          this.slideList = res.data.list;
        } else {
          console.error("res.data.err : ", res.data.err);
        }
      })
      .catch((err) => {
        alert("통신이 원활하지 않습니다.");
        console.error("err : ", err);
      });
    }
  },
};
</script>
<style lang="scss" scoped>
.program-wrapper {
  position: relative;
  padding: 40px 0px;
  color: #232323;

  .title-text {
    font-size: 33px;
    font-weight: 700;
    margin-bottom: 25px;
  }

  .slide-wrapper {
    .con {
      img {
        width: 100%;
        margin-bottom: 12px;
      }

      .text0 {
        font-size: 20px;
        font-weight: 700;
        margin-bottom: 12px;
      }

      .text1 {
        font-size: 22px;
        font-weight: 500;
        margin-bottom: 12px;
      }

      .text2 {
        font-size: 17px;
        margin-bottom: 20px;
      }

      .more {
        color: #232323;
        cursor: pointer;
      }
    }

    .slick-slider::v-deep {
      .slick-slide {
        margin-bottom: 10px;

        .slide {
          display: block !important;
        }
      }

      .slick-prev {
        left: -50px;
      }

      .slick-next {
        right: -50px;
      }

      .slick-prev,
      .slick-next {
        width: 40px;
        height: 40px;

        &::before {
          font-size: 40px;
          color: #000000;
        }
      }

      .slick-dots {
        position: relative;
        text-align: center;
        bottom: -30px;

        li {
          width: 24px;
          height: 24px;

          button {
            width: 24px;
            height: 24px;

            &::before {
              font-size: 24px;
            }
          }
        }
      }
    }
  }
}

@media screen and (min-width: 1350px) {
  .program-wrapper {
    padding: 80px 0px;

    .container {
      position: relative;
    }

    .title-text {
      font-size: 50px;
    }

    .slide-wrapper {
      .con {
        padding: 0 20px;

        img {
          width: 100%;
          margin-bottom: 20px;
        }
      }
    }
  }
}
</style>
